// whatsapp.component.ts
import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { WhatsAppService } from "../services/whats_app_service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-whatsapp',
  templateUrl: './whatsapp.component.html',
  styleUrls: ['./whatsapp.component.scss']
})
export class WhatsAppComponent implements OnDestroy {
  private _destroyed$ = new Subject<void>();
  messageForm: FormGroup;
  sending = false;
  isTemplate = true; // Add toggle for template/custom message

  constructor(
    private whatsAppService: WhatsAppService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar
  ) {
    this.messageForm = this.fb.group({
      phoneNumber: ['', Validators.required],
      messageType: ['template'], // Add radio control
      customMessage: [''], // Add field for custom message
      date: [''],
      time: ['']
    });

    // Update validators based on message type
    this.messageForm.get('messageType')?.valueChanges.pipe(takeUntil(this._destroyed$)).subscribe(type => {
      const dateControl = this.messageForm.get('date');
      const timeControl = this.messageForm.get('time');
      const customMessageControl = this.messageForm.get('customMessage');

      if (type === 'template') {
        dateControl?.setValidators([Validators.required]);
        timeControl?.setValidators([Validators.required]);
        customMessageControl?.clearValidators();
      } else {
        dateControl?.clearValidators();
        timeControl?.clearValidators();
        customMessageControl?.setValidators([Validators.required]);
      }

      dateControl?.updateValueAndValidity();
      timeControl?.updateValueAndValidity();
      customMessageControl?.updateValueAndValidity();
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  sendMessage() {
    if (this.messageForm.valid) {
      this.sending = true;
      const formValue = this.messageForm.value;

      if (formValue.messageType === 'template') {
        this.sendTemplateMessage(formValue);
      } else {
        this.sendCustomMessage(formValue);
      }
    }
  }

  private sendTemplateMessage(formValue: any) {
    this.whatsAppService.sendTemplateMessage({
      to: formValue.phoneNumber,
      contentSid: 'HXb5b62575e6e4ff6129ad7c8efe1f983e',
      templateVariables: {
        '1': formValue.date,
        '2': formValue.time
      },
      isTemplate: true
    }).subscribe(this.handleResponse.bind(this));
  }

  private sendCustomMessage(formValue: any) {
    this.whatsAppService.sendCustomMessage(
      formValue.phoneNumber,
      formValue.customMessage
    ).subscribe(this.handleResponse.bind(this));
  }

  private handleResponse(response: any) {
    this.sending = false;
    if (response.success) {
      this.snackBar.open('Message sent successfully!', 'Close', {
        duration: 3000,
        panelClass: ['success-snackbar']
      });
      this.messageForm.reset({ messageType: 'template' });
    } else {
      this.snackBar.open(response.error || 'Failed to send message', 'Close', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
    }
  }
}
